import { Component } from "@angular/core";
import { BasicUserDetails } from "src/app/auth/IBaseAuthService";
import { UsersService } from "src/app/shared/services/rest-services/users.service";
import { RouterLink, RouterOutlet } from '@angular/router';
import { NbMenuService } from "@nebular/theme";
import { filter } from "rxjs";
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent {
  user: BasicUserDetails;
  userMenu = [];

  constructor(private usersService: UsersService, private menuService: NbMenuService) {
    this.usersService.authenticateUser().then((user) => {
        this.user = user;
        this.userMenu = [
          { title: `${user.firstName} ${user.surname}`, disabled: true },
          { title: 'Log out'}
        ];
      });
    this.menuService.onItemClick()
        .pipe(filter(({ tag }) => tag === 'user-menu'))
        .subscribe(({ item }) => {
      if (item.title === 'Log out') {
        this.logout();
      }
      }
    );
  }

  logout() {
    this.usersService.logout();
  }
}
